import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'ListOpenFirst',
})
class ListOpenFirst extends Vue {
  public firstOpen = false;
  @Prop({ default: false }) private openFirst!: boolean;

  setFirstOpen(index: number, event: boolean) {
    if (index === 0) {
      this.firstOpen = event;
    }
  }

  created() {
    this.firstOpen = this.openFirst; // open by default
  }
}

export { ListOpenFirst };
